/**
 * QUIEN ES ADMIN PARA LA API: regla espejo ENTERA de nexo-api Security/AdminRolePolicy.IsAdmin (lineas 15-16):
 * el rol "admin", sin importar mayusculas ni espacios. "dev" NO cuenta: la API no lo cuenta (nexo-api 707 quito la
 * copia que lo contaba). Una sola copia en el panel para que las pantallas que esconden acciones solo-admin
 * (invitacion de registro, insignias de agentes) no se separen de la API ni entre ellas.
 *
 * Sin DOM.
 * @module domain/adminDeLaApi
 */
export function esAdminDeLaApi(rol) {
  return (rol === null || rol === undefined ? '' : String(rol).trim()).toLowerCase() === 'admin';
}
